module.exports = __webpack_public_path__ + "mainassets/img/rule_4.73fdd9ee.jpg";